import { Stack, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import {logo} from '../utils/constants'
import {Searchbar} from './'

const Navbar = () => (

  <Stack
  direction='row'
  alignItems='center'
  p={2}
  sx={{position:'sticky', background:'#000',top:0,justifyContent:'space-between'}}
  >
    <Link to='/' style={{display:'flex', alignItems:'center'}}>
    <img src={logo} alt='logo' height={45}/>
    {' '}
    <Typography color='white'>PNT</Typography>
  </Link> 
    
    <Searchbar/>
  </Stack>
)
  


export default Navbar